<template>
  <div class="w-full">
    <vx-card
      class="contactar overflow-hidden"
      @click="
        (contatoSelected = { id: null, contato: null, nome: null, tipo: null }),
          (contatosCliente = []),
          getContatos(),
          (osModal = true),
          $emit('fechar-pai')
      "
    >
      <template slot="no-body">
        <div class="item-details px-2">
          <div class="my-1">
            <vs-col
              class="p-5"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="12"
            >
              <span>
                <vs-icon color="primary" icon="contacts" size="30px"></vs-icon>
              </span>
            </vs-col>
            <vs-col
              class
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="12"
            >
              <span class="py-2" style="font-size: 18px; text-align: center"
                >CONTATOS</span
              >
            </vs-col>
          </div>
        </div>
      </template>
    </vx-card>

    <vs-popup
      ref="popupContatos"
      :active.sync="osModal"
      :title="'CONTATOS: ' + item.nomeCliente"
      class="modal-contatos"
    >
      <div id="contactar" class="vs-con-loading__container w-full">
        <div v-if="loading" style="padding: 16px 0; min-height: 200px;">
          <!-- Skeleton: action buttons row -->
          <div style="display: flex; gap: 8px; margin-bottom: 16px;">
            <div class="sk-pulse" style="height: 36px; flex: 1; border-radius: 6px;"></div>
            <div class="sk-pulse" style="height: 36px; flex: 1; border-radius: 6px;"></div>
          </div>
          <!-- Skeleton: contact cards -->
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
            <div v-for="n in 4" :key="n" class="sk-pulse" style="height: 72px; border-radius: 8px;"></div>
          </div>
          <!-- Skeleton: template select -->
          <div style="margin-top: 16px;">
            <div class="sk-pulse" style="height: 12px; width: 140px; border-radius: 4px; margin-bottom: 8px;"></div>
            <div class="sk-pulse" style="height: 38px; border-radius: 6px;"></div>
          </div>
          <!-- Skeleton: contactar button -->
          <div class="sk-pulse" style="height: 40px; border-radius: 6px; margin-top: 16px;"></div>
        </div>
        <div v-else-if="!contatosCliente.length > 0">
          <div class="con-colors mt-10 mb-20">
            <ul>
              <span
                class="px-3 pt-2"
                style="color: grey !important; font-weight: 1000 !important"
                ><vs-icon icon="sentiment_dissatisfied" size="large"></vs-icon
              ></span>
            </ul>
          </div>
        </div>
        <div v-else>
          <div class="contactar-modal-layout">
            <div class="contactar-modal-scroll" @wheel.prevent="onModalWheel">
              <div class="acoes-contato-topo mb-2">
                <div class="acoes-contato-topo__titulo">
                  Ações de confirmação
                </div>
                <vs-row vs-type="flex" vs-justify="space-between">
                  <vs-col vs-w="6" class="p-1">
                    <vs-button
                      class="w-full"
                      size="small"
                      color="warning"
                      type="filled"
                      :disabled="!canEditarContatoSelecionado"
                      @click="abrirEdicaoContato()"
                    >
                      Editar contato
                    </vs-button>
                  </vs-col>
                  <vs-col vs-w="6" class="p-1">
                    <vs-button
                      class="w-full"
                      size="small"
                      color="success"
                      type="filled"
                      :disabled="!canSelecionarContatoConfirmacao"
                      @click="abrirConfirmacaoAcao()"
                    >
                      Definir confirmação
                    </vs-button>
                  </vs-col>
                </vs-row>
              </div>

              <vs-row class="mb-3" type="flex" vs-justify="flex-start">
                <vs-col
                  v-for="(contato, index) in contatosCliente"
                  :key="index"
                  class="p-1 contato-col"
                  vs-align="flex-start"
                  vs-justify="flex-start"
                  vs-type="flex"
                  vs-w="6"
                  @click.native="
                    contato.lixeira > 0 ? null : selectContato(contato)
                  "
                >
                  <div
                    :class="[
                      'contato-card',
                      contato.id == contatoSelected.id
                        ? 'contato-card--ativo'
                        : '',
                      contato.lixeira > 0 ? 'contato-card--deletado' : '',
                      idContatoConfirmacao && contato.id == idContatoConfirmacao
                        ? 'contato-card--confirmacao'
                        : '',
                    ]"
                  >
                    <div
                      v-if="
                        idContatoConfirmacao &&
                        contato.id == idContatoConfirmacao
                      "
                      class="confirmacao-badge"
                    >
                      <vs-icon icon="star" size="10px" />
                      Contato de confirmação
                    </div>

                    <div class="contato-card-icon">
                      <vs-icon
                        :icon="contato.tipo == 1 ? 'alternate_email' : 'phone'"
                        size="16px"
                        :color="contato.lixeira > 0 ? 'white' : 'dark'"
                      />
                    </div>

                    <div class="contato-card-nome">{{ contato.nome }}</div>
                    <div class="contato-card-contato" v-if="contato.tipo == 2">
                      <contato-telefone-link :telefone="contato.contato" />
                    </div>
                    <div class="contato-card-contato" v-else>
                      {{ contato.contato }}
                    </div>
                  </div>
                </vs-col>
              </vs-row>

            </div>

            <vs-row class="mb-3 px-2">
              <vs-col vs-w="12">
                <div class="w-full">
                  <label class="text-sm mb-1 block" style="font-weight: 500;">Template de Mensagem</label>
                  <el-select
                    v-model="templateSelecionadoId"
                    class="w-full"
                    size="small"
                    placeholder="Selecione um template..."
                    :popper-append-to-body="true"
                    popper-class="popper-select-template"
                  >
                    <el-option
                      v-for="tpl in watiTemplates"
                      :key="tpl.id"
                      :value="tpl.id"
                      :label="tpl.elementName"
                    ></el-option>
                  </el-select>
                </div>
              </vs-col>
            </vs-row>

            <div class="contactar-modal-footer">
              <vs-button
                :disabled="
                  enviando ||
                  contatoSelected.contato == null || 
                  contatoSelected.tipo == 1 || 
                  !templateSelecionadoId
                "
                class="w-full"
                color="success"
                size="sm"
                type="relief"
                @click="contactar()"
              >
                <span v-if="enviando">Enviando mensagem...</span>
                <span v-else>Contactar</span>
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup
      ref="popupEditarContato"
      :active.sync="editarContatoModal"
      title="Editar contato"
      class="modal-editar-contato"
    >
      <div class="w-full">
        <vs-input
          v-model="contatoEdicao.nome"
          class="w-full mb-3"
          color="dark"
          label="Nome"
        />
        <vs-input
          v-model="contatoEdicao.contato"
          class="w-full mb-3"
          color="dark"
          label="Contato"
          @input="onContatoInput"
        />
        <el-select
          v-model="contatoEdicao.tipo"
          class="w-full"
          size="small"
          placeholder="Tipo"
          :popper-append-to-body="true"
          popper-class="popper-editar-contato"
        >
          <el-option
            v-for="tipoContato in tiposContatoEdicao"
            :key="tipoContato.value"
            :value="tipoContato.value"
            :label="tipoContato.label"
          ></el-option>
        </el-select>

        <vs-row class="mt-3" vs-type="flex" vs-justify="flex-end">
          <vs-button
            size="small"
            color="success"
            :disabled="!canSalvarContatoEditado"
            @click="salvarEdicaoContato()"
          >
            Salvar
          </vs-button>
        </vs-row>
      </div>
    </vs-popup>

    <vs-popup
      ref="popupConfirmacao"
      :active.sync="modalConfirmacaoAcao"
      :title="confirmacaoAcao.titulo"
      class="modal-confirmacao-contato"
    >
      <div class="w-full">
        <p class="confirmacao-texto">{{ confirmacaoAcao.texto }}</p>
        <vs-row class="mt-3" vs-type="flex" vs-justify="flex-end">
          <vs-button
            class="mr-2"
            color="dark"
            type="border"
            size="small"
            @click="modalConfirmacaoAcao = false"
          >
            Cancelar
          </vs-button>
          <vs-button
            color="success"
            type="filled"
            size="small"
            @click="confirmarAcaoContato()"
          >
            Confirmar
          </vs-button>
        </vs-row>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import ContatoTelefoneLink from "@/components/default/ContatoTelefoneLink.vue";
import { buildGetWatiTemplatesUrl } from "@/constants/watiTemplates";
export default {
  components: { ContatoTelefoneLink },
  props: {
    item: {
      required: true,
    },
    tipo: {
      required: true,
    },
  },
  data() {
    return {
      osModal: false,
      loading: false,
      contatosCliente: [],
      contatoSelected: { id: null, contato: null, nome: null, tipo: null },
      idContatoConfirmacao: null,
      watiTemplates: [],
      templateSelecionadoId: null,
      enviando: false,

      editarContatoModal: false,
      contatoEdicao: {
        id: null,
        nome: "",
        contato: "",
        tipo: "2",
        id_setor: null,
      },

      tiposContatoEdicao: [
        { value: "1", label: "E-mail" },
        { value: "2", label: "Telefone" },
      ],

      modalConfirmacaoAcao: false,
      confirmacaoAcao: {
        tipo: null,
        titulo: "Confirmar ação",
        texto: "",
      },

    };
  },
  computed: {
    watiUrl() {
      return process.env.VUE_APP_WATI_URL || '';
    },
    canSelecionarContatoConfirmacao() {
      return (
        this.item.id_contrato > 0 &&
        this.contatoSelected &&
        this.contatoSelected.id > 0 &&
        this.contatoSelected.lixeira <= 0
      );
    },
    canEditarContatoSelecionado() {
      return (
        this.contatoSelected &&
        this.contatoSelected.id > 0 &&
        this.contatoSelected.lixeira <= 0
      );
    },
    canSalvarContatoEditado() {
      return (
        this.contatoEdicao.id > 0 &&
        this.contatoEdicao.nome &&
        this.contatoEdicao.nome.trim().length > 0 &&
        this.contatoEdicao.contato &&
        this.contatoEdicao.contato.trim().length > 0
      );
    },
  },
  watch: {
    osModal() {
      this.ajustarZIndexPopups();
    },
    editarContatoModal() {
      this.ajustarZIndexPopups();
    },
    modalConfirmacaoAcao() {
      this.ajustarZIndexPopups();
    },
    "contatoEdicao.tipo"(newTipo) {
      if (newTipo === "2") {
        this.onContatoInput(this.contatoEdicao.contato);
      } else {
        this.contatoEdicao.contato = this.contatoEdicao.contato.replace(/[()-\s]/g, "");
      }
    },
  },
  mounted() {
    this.ajustarZIndexPopups();
  },
  methods: {
    ajustarZIndexPopups() {
      this.$nextTick(() => {
        const setZ = (refName, zIndex) => {
          const popup = this.$refs[refName];
          const el = popup && popup.$refs && popup.$refs.con;
          if (el) {
            el.style.zIndex = String(zIndex);
          }
        };

        setZ("popupContatos", 62000);
        if (this.editarContatoModal) {
          setZ("popupEditarContato", 64000);
        }
        if (this.modalConfirmacaoAcao) {
          setZ("popupConfirmacao", 65000);
        }
      });
    },
    onModalWheel(event) {
      const container = event.currentTarget;
      if (!container) return;
      container.scrollTop += event.deltaY;
    },

    normalizarTelefoneWati(contato) {
      if (Number(contato.tipo) !== 2) return "";
      let normalizado = String(contato.contato).replace(/\D/g, "");
      if (normalizado.length === 8 || normalizado.length === 9) {
        normalizado = "92" + normalizado;
      }
      if (!normalizado.startsWith("55")) normalizado = "55" + normalizado;
      if (normalizado.length === 13 && normalizado[4] === "9") {
        normalizado = normalizado.slice(0, 4) + normalizado.slice(5);
      }
      return normalizado;
    },

    async getContatos() {
      this.loading = true;
      await this.$vs.loading({ container: "#contactar", scale: 0.6 });
      try {
        const [contatosApi] = await Promise.all([
          this.$http.get("contatoCliente/" + this.item.id_cliente),
          this.getWatiTemplates()
        ]);
        
        this.contatosCliente = (contatosApi || [])
          .filter((contato) => Number(contato.lixeira || 0) === 0)
          .map((contato) => ({
            ...contato,
            tipo: this.normalizarTipoContato(contato.tipo),
            numeroWati: this.normalizarTelefoneWati(contato),
          }));

        this.idContatoConfirmacao = this.item.id_contato_confirmacao || null;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        this.loading = false;
        await this.$vs.loading.close("#contactar > .con-vs-loading");
      }
    },
    async getWatiTemplates() {
      try {
        const url = buildGetWatiTemplatesUrl(this.tipo);
        let res = await this.$http.get(url);
        let lista = [];
        if (res && res.data) {
          lista = res.data.data ? res.data.data : (Array.isArray(res.data) ? res.data : (res.data.messageTemplates || []));
        }

        // Se o filtro estrito não encontrou nenhum template no WATI mas existem templates aprovados, faz fallback defensivo
        if ((!lista || lista.length === 0) && this.tipo) {
          const fallbackRes = await this.$http.get("getWatiTemplates?filtro[status][]=approved");
          if (fallbackRes && fallbackRes.data) {
            lista = fallbackRes.data.data ? fallbackRes.data.data : (Array.isArray(fallbackRes.data) ? fallbackRes.data : (fallbackRes.data.messageTemplates || []));
          }
        }

        this.watiTemplates = Array.isArray(lista) ? lista : [];
      } catch (err) {
        let errorMsg = "Erro ao buscar templates";
        if (err.response && err.response.data && err.response.data.message) {
          errorMsg = err.response.data.message;
        }
        this.$vs.notify({
          title: "Erro",
          text: errorMsg,
          color: "danger",
        });
      }
    },
    abrirConfirmacaoAcao() {
      if (!this.canSelecionarContatoConfirmacao) {
        return;
      }
      this.confirmacaoAcao.tipo = "definir";
      this.confirmacaoAcao.titulo = "Confirmar ação";
      this.confirmacaoAcao.texto =
        "Tem certeza que deseja definir este contato como contato de confirmação?";
      this.modalConfirmacaoAcao = true;
    },
    async confirmarAcaoContato() {
      this.modalConfirmacaoAcao = false;
      await this.definirContatoConfirmacao();
    },
    async definirContatoConfirmacao() {
      if (!this.canSelecionarContatoConfirmacao) {
        return;
      }

      await this.$vs.loading({ container: "#contactar", scale: 0.6 });
      try {
        await this.$http.put("contrato/" + this.item.id_contrato, {
          id_contato_confirmacao: this.contatoSelected.id,
        });

        this.idContatoConfirmacao = this.contatoSelected.id;
        this.$emit("confirmacao-atualizada", {
          idContrato: this.item.id_contrato,
          idContatoConfirmacao: this.contatoSelected.id,
          nomeContatoConfirmacao: this.contatoSelected.nome,
          contatoConfirmacao: this.contatoSelected.contato,
        });

        await this.$vs.notify({
          title: "Sucesso",
          text: "Contato de confirmação atualizado.",
          color: "success",
        });
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
      await this.$vs.loading.close("#contactar > .con-vs-loading");
    },
    onContatoInput(val) {
      if (this.contatoEdicao.tipo === "2") {
        let x = val.replace(/\D/g, ""); // Keep only numbers
        if (x.length > 11) {
          x = x.slice(0, 11);
        }
        if (x.length <= 10) {
          // (XX) XXXX-XXXX
          this.contatoEdicao.contato = x.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3")
                                        .replace(/^(\d{2})(\d{4})(\d)/, "($1) $2-$3")
                                        .replace(/^(\d{2})(\d)/, "($1) $2")
                                        .replace(/^(\d)/, "($1");
        } else {
          // (XX) XXXXX-XXXX
          this.contatoEdicao.contato = x.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3")
                                        .replace(/^(\d{2})(\d{5})(\d)/, "($1) $2-$3")
                                        .replace(/^(\d{2})(\d)/, "($1) $2")
                                        .replace(/^(\d)/, "($1");
        }
      }
    },
    async abrirEdicaoContato() {
      if (!this.canEditarContatoSelecionado) {
        return;
      }

      this.contatoEdicao = {
        id: this.contatoSelected.id,
        nome: this.contatoSelected.nome || "",
        contato: this.contatoSelected.contato || "",
        tipo: this.normalizarTipoContato(this.contatoSelected.tipo),
        id_setor: this.contatoSelected.id_setor || null,
      };
      
      if (this.contatoEdicao.tipo === "2") {
        this.onContatoInput(this.contatoEdicao.contato);
      }
      this.editarContatoModal = true;
    },
    async salvarEdicaoContato() {
      if (!this.canSalvarContatoEditado) {
        return;
      }

      await this.$vs.loading({ container: "#contactar", scale: 0.6 });
      try {
        await this.$http.put("contato/" + this.contatoEdicao.id, {
          nome: this.contatoEdicao.nome,
          contato: this.contatoEdicao.contato,
          tipo: Number(this.contatoEdicao.tipo),
          id_setor: this.contatoEdicao.id_setor,
        });

        await this.getContatos();
        const contatoAtualizado = this.contatosCliente.find(
          (x) => x.id == this.contatoEdicao.id,
        );
        if (contatoAtualizado) {
          await this.selectContato(contatoAtualizado);
        }

        this.editarContatoModal = false;
        await this.$vs.notify({
          title: "Sucesso",
          text: "Contato atualizado com sucesso.",
          color: "success",
        });
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
      await this.$vs.loading.close("#contactar > .con-vs-loading");
    },
    async selectContato(contato) {
      this.contatoSelected = Object.assign(contato);
    },
    normalizarTipoContato(tipo) {
      if (tipo === null || tipo === undefined || tipo === "") {
        return "2";
      }
      const valor = String(tipo).trim().toLowerCase();
      if (valor === "1" || valor === "email" || valor === "e-mail") {
        return "1";
      }
      if (valor === "2" || valor === "telefone" || valor === "phone") {
        return "2";
      }
      return "2";
    },
    // formatarData(data) {
    //   const dataObj = new Date(data);
    //   const formatador = new Intl.DateTimeFormat("pt-BR");
    //   return formatador.format(dataObj);
    // },
    async contactar() {
      if (this.enviando) return;
      if (
        this.contatoSelected.contato == null ||
        this.contatoSelected.tipo == 1 ||
        !this.templateSelecionadoId
      ) {
        return;
      }
      this.enviando = true;
      await this.$vs.loading({ container: "#contactar", scale: 0.6 });
      try {
        const template = this.watiTemplates.find(t => t.id === this.templateSelecionadoId);
        const equipes = this.tipo == "os_confirmacao" ? ["Equipe Confirmação"] : null;
        const res = await this.$http.post("enviarWhatsapp", {
          idOs: this.item.id,
          idContato: this.contatoSelected.id,
          templateName: template ? template.elementName : this.tipo,
          templateId: this.templateSelecionadoId,
          equipes,
          tipo: this.tipo
        });

        const etapas = (res && res.data) || {};

        if (equipes && equipes.length > 0 && etapas.direcionamentoEquipe && !etapas.direcionamentoEquipe.sucesso) {
          await this.$vs.notify({
            title: "Atenção",
            text: (res && res.message) || "Mensagem enviada, mas houve falha com a equipe.",
            color: "warning",
          });
        } else {
          await this.$vs.notify({
            title: "Sucesso!",
            text: (res && res.message) || "Mensagem enviada com sucesso!",
            color: "success",
          });
        }
      } catch (err) {
        console.log(err);
        const errorData = (err && err.response && err.response.data) || {};
        console.log(errorData);
        let errorMsg = errorData.message || "Erro ao enviar mensagem.";
          
        let detalhe = "";
        if (errorData.errors && errorData.errors.envioMensagem) {
            detalhe = errorData.errors.envioMensagem.detalhe;
        } else if (Array.isArray(errorData.errors) && errorData.errors.length > 0) {
            detalhe = errorData.errors[0].message || "";
        } else if (typeof errorData.errors === 'string') {
            detalhe = errorData.errors;
        }

        this.$vs.notify({
          title: "Erro",
          text: detalhe ? `${errorMsg} (${detalhe})` : errorMsg,
          color: "danger",
        });

        if (err && err.response && err.response.status === 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        this.enviando = false;
        await this.$vs.loading.close("#contactar > .con-vs-loading");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.spin-anim {
  animation: spin 1s linear infinite;
}
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.sk-pulse {
  background: linear-gradient(90deg, #e2e8f0 25%, #f0f4f8 50%, #e2e8f0 75%);
  background-size: 200% 100%;
  animation: sk-shimmer 1.4s infinite;
}
@keyframes sk-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.contactar {
  transition-duration: 50ms;

  &:hover {
    transition-duration: 150ms;
    transform: translateY(-3px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);
    background-color: #ffca00;
    color: #1f2937;
    cursor: pointer;

    .grid-view-img {
      opacity: 0.9;
    }
  }
}

.acoes-contato-topo {
  background: #f1f8ff;
  border: 1px solid #cfe8ff;
  border-radius: 8px;
  padding: 8px;
}

.acoes-contato-topo__titulo {
  font-size: 12px;
  font-weight: 700;
  color: #000;
  margin-bottom: 4px;
}

.confirmacao-texto {
  color: #334155;
  font-size: 14px;
  margin: 0;
}

#contactar {
  max-height: 75vh;
}

.contactar-modal-layout {
  display: flex;
  flex-direction: column;
  max-height: 75vh;
}

.contactar-modal-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding-right: 2px;
}

.contactar-modal-footer {
  flex-shrink: 0;
  background: #fff;
  border-top: 1px solid #e2e8f0;
  padding-top: 10px;
  margin-top: 8px;
}

.contato-col {
  cursor: pointer;
}

/* ── Cards de contato ── */
.contato-card {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  padding: 14px 14px 12px;
  border-radius: 8px;
  border: 1.5px solid #e2e8f0;
  background: #f8f9fa;
  cursor: pointer;
  transition: all 0.15s ease;
  overflow: hidden;
}

.contato-card:hover {
  border-color: #94a3b8;
  background: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.contato-card--ativo {
  background: #00bba24b !important;
  border-color: #00bba2 !important;
  box-shadow: 0 4px 12px rgba(21, 198, 2, 0.039) !important;
}

.contato-card--ativo .contato-card-nome,
.contato-card--ativo .contato-card-contato {
  color: #1a1a1a !important;
}

.contato-card--deletado {
  cursor: not-allowed;
  background: #c0564b !important;
  border-color: #a03d33 !important;
}

.contato-card--deletado .contato-card-nome,
.contato-card--deletado .contato-card-contato {
  color: #fff !important;
}

/* confirmacao: só borda verde, sem background */
.contato-card--confirmacao {
  border-width: 2px !important;
}

.contato-card-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  opacity: 0.4;
}

.contato-card-nome {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 24px;
  margin-top: 14px; /* espaço pro badge */
}

.contato-card-contato {
  font-size: 13px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Badge no topo — ocupa espaço próprio com margin-top no nome */
.confirmacao-badge {
  position: absolute;
  top: 0;
  left: 0;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  background: #00bba2;
  color: #fff;
  border-radius: 0 0 6px 0;
  font-size: 9px;
  font-weight: 700;
  padding: 2px 7px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  line-height: 1.5;
}

::v-deep .modal-editar-contato {
  z-index: 1 !important;
}

::v-deep .modal-editar-contato .vs-popup {
  z-index: 64001 !important;
}

::v-deep .modal-editar-contato .vs-popup--background {
  z-index: 64000 !important;
}

::v-deep .modal-confirmacao-contato {
  z-index: 65000 !important;
}

::v-deep .modal-confirmacao-contato .vs-popup {
  z-index: 65001 !important;
}

::v-deep .modal-confirmacao-contato .vs-popup--background {
  z-index: 65000 !important;
}

::v-deep .modal-contatos {
  z-index: 62000 !important;
}

::v-deep .modal-contatos .vs-popup {
  z-index: 62001 !important;
}

::v-deep .modal-contatos .vs-popup--background {
  z-index: 62000 !important;
}

</style>

<style lang="scss">
.popper-editar-contato {
  z-index: 66000 !important;
}

.popper-select-template {
  z-index: 99999 !important;
}
</style>
